module.exports = __webpack_public_path__ + "static/media/map-marker.658b8302.svg";